import App from "../App";

// Temporary routing shim: renders the legacy monolith.
// Follow-up: replace with real route components (ChatRoute, SettingsRoute, ProfileRoute).
export function AppRoutes() {
  return <App />;
}
